/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Attachments from '../Common/attachments';
import DescriptionField from '../Common/descriptionField';
import WorkerSelect from '../Common/workerSelect';
import OwnerSelect from '../Common/ownerSelect';
import SelectField from '../Common/selectField';
import AcceptanceCriteria from '../Criteria/acceptanceCriteria';
import { allows } from '../../utils/authorization';
import ProductSelect from '../Common/productSelect';
import {
  generateParentOptions,
  generateTeamOptions
} from '../../utils/resultModalHelpers';

class DetailsTab extends React.Component {
  // eslint-disable-next-line react/state-in-constructor
  state = {
    isFull: false,
    isCriteriaFull: false
  };

  toggleIsFull = () =>
    this.setState((prevState) => ({ isFull: !prevState.isFull }));

  toggleCriteriaFull = () =>
    this.setState((prevState) => ({
      isCriteriaFull: !prevState.isCriteriaFull
    }));

  render() {
    const {
      feature,
      parents,
      team,
      product,
      criteria,
      attachmentList,
      onSelectChange,
      teams
    } = this.props;
    const { isFull, isCriteriaFull } = this.state;
    const allowEdit = allows('update', feature);
    const parent = parents.find((p) => p.id === feature.parent_id) || {};

    const { teamOptions, selectedTeam } = generateTeamOptions(
      product.teams || teams,
      team
    );

    const { selectedParent, parentOptions } = generateParentOptions(
      parents,
      parent
    );

    return (
      <div className="details-tab">
        {!isCriteriaFull && (
          <div className={`row top-description ${isFull ? 'full' : ''}`}>
            <DescriptionField
              id={feature.id || ''}
              description={feature.description || ''}
              type="WorkPackage"
              onFieldChange={this.props.handleUpdate}
              allowEdit={allowEdit}
              isFull={isFull}
              toggleIsFull={this.toggleIsFull}
            />
            {!isFull && (
              <div className="detail-tab-right selects-column">
                <ProductSelect
                  allowEdit={allowEdit}
                  onSelectChange={onSelectChange}
                  selectedTeam={selectedTeam}
                  selectedProductId={feature.product_id}
                />
                <SelectField
                  label="Team"
                  value={selectedTeam}
                  options={teamOptions}
                  allowEdit={allowEdit && teamOptions.length > 0}
                  handleChange={onSelectChange}
                  clearable={!!feature.product_id}
                />
                <WorkerSelect
                  label="Owner"
                  selectedWorker={{ id: feature.owner_id }}
                  allowEdit={allowEdit}
                  onUpdate={onSelectChange}
                  result={feature}
                />
                <OwnerSelect
                  label="Product Owner"
                  selectedOwner={{ id: feature.product_owner_id }}
                  allowEdit={allowEdit}
                  onUpdate={onSelectChange}
                  result={feature}
                />
                <SelectField
                  label="Parent"
                  value={selectedParent}
                  options={parentOptions}
                  allowEdit={allowEdit}
                  handleChange={onSelectChange}
                />
              </div>
            )}
          </div>
        )}
        {!isFull && (
          <div className="row bottom-ac">
            <div className="ac-container">
              <AcceptanceCriteria
                addCriteria={this.props.addCriteria}
                removeCriteria={this.props.removeCriteria}
                workPackage={feature}
                isNew={!feature.id}
                criteria={criteria}
                isCriteriaFull={isCriteriaFull}
                toggleCriteriaFull={this.toggleCriteriaFull}
                detailCard
              />
            </div>
            {!isCriteriaFull && (
              <Attachments
                itemId={feature.id}
                type="workPackage"
                allowCreate={allows('create_attachments', feature)}
                allowDelete={allows('destroy_attachments', feature)}
                attachmentList={attachmentList}
                addAttachment={this.props.addAttachment}
                removeAttachment={this.props.removeAttachment}
                isNew={!feature.id}
              />
            )}
          </div>
        )}
      </div>
    );
  }
}

DetailsTab.propTypes = {
  feature: PropTypes.object.isRequired,
  parents: PropTypes.array.isRequired,
  capabilities: PropTypes.array.isRequired,
  handleUpdate: PropTypes.func
};

const mapStateToProps = (state) => {
  return {
    teams: state.teamReducer.teams
  };
};

export default connect(mapStateToProps)(DetailsTab);
